import Sidemenu from '../components/base/sidemenu';
import AdminQna from '../components/qna/adminqna';

export default function DashboardPage() {
    return (
        <div className='flex'>
            <Sidemenu />
            <AdminQna />
        </div>
    );
}
